import React from "react";

function PageTitle({ title, subtitle, icon }) {
  return (
    <div className="page-title">
      <div className="page-title-row">
        {icon ? <span className="page-title-icon">{icon}</span> : null}
        <h3 className="page-title-text">{title}</h3>
      </div>
      {subtitle ? <p className="page-title-subtitle">{subtitle}</p> : null}
      <span className="page-title-accent" aria-hidden="true" />
    </div>
  );
}

export default PageTitle;
